import { PersonaFisicaConfig as config } from "@/pages/parametros/moduleConfig";
import NewView from "@/pages/parametros/add-edit/NewView.vue";
import EditView from "@/pages/parametros/add-edit/EditView.vue";
import isUserRolGuard from "@/guards/isUserRolGuard";

export default [
  {
    //'parametros/persona-fisica'
    path: "persona-fisica",
    name: "persona-fisica",
    beforeEnter: isUserRolGuard,
    // component:   () => import ('@/pages/parametros/pais.vue'),
    component: () => import("@/pages/parametros/TemplateView.vue"),
    props: { config: config.templateTable },
  },
  {
    //'parametros/persona-fisica/new'
    path: "persona-fisica/new",
    name: "persona-fisica-new",
    component: () => import("@/pages/parametros/add-edit/NewView.vue"),
    beforeEnter: isUserRolGuard,
    props: { config: config.form },
  },
  {
    //'parametros/persona-fisica/edit/:id'
    path: "persona-fisica/edit/:id",
    component: () => import("@/pages/parametros/add-edit/EditView.vue"),
    beforeEnter: isUserRolGuard,
    props: { config: config.form },
  },
];
